import { render, staticRenderFns } from "./SplashScreenForm.vue?vue&type=template&id=635dd012&scoped=true&"
import script from "./SplashScreenForm.vue?vue&type=script&lang=js&"
export * from "./SplashScreenForm.vue?vue&type=script&lang=js&"
import style0 from "./SplashScreenForm.vue?vue&type=style&index=0&id=635dd012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635dd012",
  null
  
)

export default component.exports